import { render } from "./Price.vue?vue&type=template&id=7b7cd439&scoped=true&ts=true"
import script from "./Price.vue?vue&type=script&lang=ts"
export * from "./Price.vue?vue&type=script&lang=ts"

import "./Price.vue?vue&type=style&index=0&id=7b7cd439&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b7cd439"]])

export default __exports__